export const BANNER = {
  BASE_PATH: "/others/banner/",
  ADD_PATH() {
    return this.BASE_PATH + "add";
  },
  ADD_BUTTON_TITLE: "Add New Banner",
  LIST_PAGE_TITLE: "Banner List",
  ADD_NEW_TITLE: "Add New Banner",
  GET_ALL: "/banner/list",
  CREATE: "/banner/create",
  DELETE: "/banner/delete/",
};
